export const iconFontAwesomeWritingNoteSticky = (
	<i className="fa-solid fa-note-sticky"></i>
);
